import type { TOptions, TPlayer } from 'video.js'
import type { TextTrackCustomSettings } from '|>/components/settings/subtitles/text-track-custom-settings'

import { setSubtitleClasses } from '|>/components/settings/subtitles/set-subtitle-classes'
import { getTextTrackCustomSettings } from '|>/components/settings/subtitles/text-track-custom-settings'
import { Events } from '|>/shared/events'

/**
 * Configure text track custom settings addon before player initialization
 */
export function configure(options: TOptions): TOptions {
  return options
}

/**
 * Injects text track custom settings functionality into the player
 */
export function inject(player: TPlayer): TPlayer {
  // Load settings from localStorage and apply classes
  const settings = getTextTrackCustomSettings()
  setSubtitleClasses(player, settings)

  // Listen for settings update events
  player.on(
    Events.TextTrack.CustomSettingsUpdated,
    (
      _event: any,
      data: { settings: TextTrackCustomSettings } | TextTrackCustomSettings
    ) => {
      // Support both event formats
      const settings = 'settings' in data ? data.settings : data
      setSubtitleClasses(player, settings)
    }
  )

  return player
}
